import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-left-down', 'IconCornerLeftDown', [
  ['path', { d: 'M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4', key: 'svg-0' }],
]);
